import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, UpdateInvoiceCarrierPayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'UPDATE_INVOICE_CARRIER_',
  }
);

export interface UpdateInvoiceCarrierState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface UpdateInvoiceCarrierRequestAction {
  payload: UpdateInvoiceCarrierPayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: UpdateInvoiceCarrierState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: UpdateInvoiceCarrierState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: UpdateInvoiceCarrierState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: UpdateInvoiceCarrierState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: UpdateInvoiceCarrierState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const updateInvoiceCarrier = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const UpdateInvoiceCarrierTypes = Types;
export const UpdateInvoiceCarrierActions = Creators;
